export default __webpack_public_path__ + "bd0e72459ec64196467da36140154dba.png";